module.exports = __webpack_public_path__ + "static/media/DT_Logo.a45a5efd.png";